import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["style", "className", "children"];
import * as React from 'react';
import ClassNames from 'classnames';
;
var ModalFooter = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$style = _ref.style,
    style = _ref$style === void 0 ? {
      justifyContent: 'flex-end'
    } : _ref$style,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    children = _ref.children,
    others = _objectWithoutPropertiesLoose(_ref, _excluded);
  var classNames = ClassNames('ap-modal-footer', className);
  return /*#__PURE__*/React.createElement("div", _extends({
    className: classNames,
    ref: ref,
    style: style
  }, others), /*#__PURE__*/React.createElement("div", {
    className: "ap-modal-footer-customize"
  }, children));
});
export default ModalFooter;